import { render, staticRenderFns } from "./ChatSendButton.vue?vue&type=template&id=65d4b33b&scoped=true&"
import script from "./ChatSendButton.vue?vue&type=script&lang=js&"
export * from "./ChatSendButton.vue?vue&type=script&lang=js&"
import style0 from "./ChatSendButton.vue?vue&type=style&index=0&id=65d4b33b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d4b33b",
  null
  
)

export default component.exports